export const EXAM_TYPES = ['중간고사', '기말고사', '모의고사'];

export const GRADES = ['중1', '중2', '중3', '고1', '고2', '고3'];

export const MONTHS = ['3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

export const EXAM_TYPE_TONE: Record<string, string> = {
  중간고사: 'bg-primary-100 text-primary-700',
  기말고사: 'bg-secondary-100 text-secondary-900',
  모의고사: 'bg-accent-100 text-accent-800',
};

export interface SubjectGroup {
  category: string;
  subjects: string[];
}

// 이미 본 시험의 과목별 성적을 기록할 때 고르는 과목 목록 (중학교 / 고등학교 구분)
export const SUBJECT_GROUPS: SubjectGroup[] = [
  {
    category: '중학교 과목',
    subjects: [
      '국어',
      '수학',
      '영어',
      '사회',
      '역사',
      '과학',
      '도덕',
      '기술·가정',
      '정보',
      '한문',
      '음악',
      '미술',
      '체육',
    ],
  },
  {
    category: '고등학교 과목',
    subjects: [
      '공통국어1',
      '공통국어2',
      '독서',
      '문학',
      '언어와 매체',
      '화법과 작문',
      '공통수학1',
      '공통수학2',
      '대수',
      '미적분Ⅰ',
      '미적분Ⅱ',
      '확률과 통계',
      '기하',
      '공통영어1',
      '공통영어2',
      '영어Ⅰ',
      '영어Ⅱ',
      '독해와 작문',
      '한국사',
      '통합사회',
      '통합과학',
      '과학탐구실험',
      '생활과 윤리',
      '윤리와 사상',
      '한국지리',
      '세계지리',
      '동아시아사',
      '세계사',
      '경제',
      '정치와 법',
      '사회·문화',
      '물리학Ⅰ',
      '화학Ⅰ',
      '생명과학Ⅰ',
      '지구과학Ⅰ',
      '물리학Ⅱ',
      '화학Ⅱ',
      '생명과학Ⅱ',
      '지구과학Ⅱ',
      '일본어',
      '중국어',
      '음악',
      '미술',
      '체육',
    ],
  },
];

export const SUBJECT_OPTIONS: string[] = SUBJECT_GROUPS.flatMap((g) => g.subjects);